module.exports = __webpack_public_path__ + "img/11069859_L.e15aeea3.png";